import { mediaData } from '@/mocks/home';

export default function SectionMedia() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            视频爆料
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            实锤视频证据，一眼看穿真相（静态预览，点击查看完整专题）
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaData.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl overflow-hidden hover:bg-background-200/70 transition-colors cursor-pointer group"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-secondary-200">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    const parent = target.parentElement;
                    if (parent) {
                      parent.style.display = 'none';
                    }
                  }}
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-foreground-50/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-primary-500 text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/60 text-foreground-50 text-xs rounded">
                  {item.duration}
                </span>
                <span className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded">
                  {item.tag}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <p className="text-sm text-foreground-900 font-medium leading-snug line-clamp-2 mb-2">
                  {item.title}
                </p>
                <span className="text-xs text-foreground-500 flex items-center gap-1">
                  <i className="ri-eye-line text-[10px]"></i>
                  {item.views} 次观看
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}